
export const countries = [
    { alpha3: "AFG" },
    { alpha3: "ALB" },
    { alpha3: "DZA" },
    { alpha3: "AND" },
    { alpha3: "AGO" },
    { alpha3: "ATG" },
    { alpha3: "ARG" },
    { alpha3: "ARM" },
    { alpha3: "AUS" },
    { alpha3: "AUT" },
    { alpha3: "AZE" },
    { alpha3: "BHS" },
    { alpha3: "BHR" },
    { alpha3: "BGD" },
    { alpha3: "BRB" },
    { alpha3: "BLR" },
    { alpha3: "BEL" },
    { alpha3: "BLZ" },
    { alpha3: "BEN" },
    { alpha3: "BTN" },
    { alpha3: "BOL" },
    { alpha3: "BIH" },
    { alpha3: "BWA" },
    { alpha3: "BRA" },
    { alpha3: "BRN" },
    { alpha3: "BGR" },
    { alpha3: "BFA" },
    { alpha3: "BDI" },
    { alpha3: "CPV" },
    { alpha3: "KHM" },
    { alpha3: "CMR" },
    { alpha3: "CAN" },
    { alpha3: "CAF" },
    { alpha3: "TCD" },
    { alpha3: "CHL" },
    { alpha3: "CHN" },
    { alpha3: "COL" },
    { alpha3: "COM" },
    { alpha3: "COG" },
    { alpha3: "COD" },
    { alpha3: "CRI" },
    { alpha3: "HRV" },
    { alpha3: "CUB" },
    { alpha3: "CYP" },
    { alpha3: "CZE" },
    { alpha3: "DNK" },
    { alpha3: "DJI" },
    { alpha3: "DMA" },
    { alpha3: "DOM" },
    { alpha3: "ECU" },
    { alpha3: "EGY" },
    { alpha3: "SLV" },
    { alpha3: "GNQ" },
    { alpha3: "ERI" },
    { alpha3: "EST" },
    { alpha3: "SWZ" },
    { alpha3: "ETH" },
    { alpha3: "FJI" },
    { alpha3: "FIN" },
    { alpha3: "FRA" },
    { alpha3: "GAB" },
    { alpha3: "GMB" },
    { alpha3: "GEO" },
    { alpha3: "DEU" },
    { alpha3: "GHA" },
    { alpha3: "GRC" },
    { alpha3: "GRD" },
    { alpha3: "GTM" },
    { alpha3: "GIN" },
    { alpha3: "GNB" },
    { alpha3: "GUY" },
    { alpha3: "HTI" },
    { alpha3: "HND" },
    { alpha3: "HUN" },
    { alpha3: "ISL" },
    { alpha3: "IND" },
    { alpha3: "IDN" },
    { alpha3: "IRN" },
    { alpha3: "IRQ" },
    { alpha3: "IRL" },
    { alpha3: "ISR" },
    { alpha3: "ITA" },
    { alpha3: "JAM" },
    { alpha3: "JPN" },
    { alpha3: "JOR" },
    { alpha3: "KAZ" },
    { alpha3: "KEN" },
    { alpha3: "KIR" },
    { alpha3: "KWT" },
    { alpha3: "KGZ" },
    { alpha3: "LAO" },
    { alpha3: "LVA" },
    { alpha3: "LBN" },
    { alpha3: "LSO" },
    { alpha3: "LBR" },
    { alpha3: "LBY" },
    { alpha3: "LIE" },
    { alpha3: "LTU" },
    { alpha3: "LUX" },
    { alpha3: "MDG" },
    { alpha3: "MWI" },
    { alpha3: "MYS" },
    { alpha3: "MDV" },
    { alpha3: "MLI" },
    { alpha3: "MLT" },
    { alpha3: "MHL" },
    { alpha3: "MRT" },
    { alpha3: "MUS" },
    { alpha3: "MEX" },
    { alpha3: "FSM" },
    { alpha3: "MCO" },
    { alpha3: "MNG" },
    { alpha3: "MNE" },
    { alpha3: "MAR" },
    { alpha3: "MOZ" },
    { alpha3: "MMR" },
    { alpha3: "NAM" },
    { alpha3: "NRU" },
    { alpha3: "NPL" },
    { alpha3: "NLD" },
    { alpha3: "NZL" },
    { alpha3: "NIC" },
    { alpha3: "NER" },
    { alpha3: "NGA" },
    { alpha3: "PRK" },
    { alpha3: "MKD" },
    { alpha3: "NOR" },
    { alpha3: "OMN" },
    { alpha3: "PAK" },
    { alpha3: "PLW" },
    { alpha3: "PAN" },
    { alpha3: "PNG" },
    { alpha3: "PRY" },
    { alpha3: "PER" },
    { alpha3: "PHL" },
    { alpha3: "POL" },
    { alpha3: "PRT" },
    { alpha3: "QAT" },
    { alpha3: "KOR" },
    { alpha3: "MDA" },
    { alpha3: "ROU" },
    { alpha3: "RUS" },
    { alpha3: "RWA" },
    { alpha3: "KNA" },
    { alpha3: "LCA" },
    { alpha3: "VCT" },
    { alpha3: "WSM" },
    { alpha3: "SMR" },
    { alpha3: "STP" },
    { alpha3: "SAU" },
    { alpha3: "SEN" },
    { alpha3: "SRB" },
    { alpha3: "SYC" },
    { alpha3: "SLE" },
    { alpha3: "SGP" },
    { alpha3: "SVK" },
    { alpha3: "SVN" },
    { alpha3: "SLB" },
    { alpha3: "SOM" },
    { alpha3: "ZAF" },
    { alpha3: "SSD" },
    { alpha3: "ESP" },
    { alpha3: "LKA" },
    { alpha3: "SDN" },
    { alpha3: "SUR" },
    { alpha3: "SWE" },
    { alpha3: "CHE" },
    { alpha3: "SYR" },
    { alpha3: "TJK" },
    { alpha3: "THA" },
    { alpha3: "TLS" },
    { alpha3: "TGO" },
    { alpha3: "TON" },
    { alpha3: "TTO" },
    { alpha3: "TUN" },
    { alpha3: "TUR" },
    { alpha3: "TKM" },
    { alpha3: "TUV" },
    { alpha3: "UGA" },
    { alpha3: "UKR" },
    { alpha3: "ARE" },
    { alpha3: "GBR" },
    { alpha3: "TZA" },
    { alpha3: "USA" },
    { alpha3: "URY" },
    { alpha3: "UZB" },
    { alpha3: "VUT" },
    { alpha3: "VEN" },
    { alpha3: "VNM" },
    { alpha3: "YEM" },
    { alpha3: "ZMB" },
    { alpha3: "ZWE" },];

const alpha2ToAlpha3Mapping: Record<string, string> = {
    "AF": "AFG",
    "AL": "ALB",
    "DZ": "DZA",
    "AD": "AND",
    "AO": "AGO",
    "AG": "ATG",
    "AR": "ARG",
    "AM": "ARM",
    "AU": "AUS",
    "AT": "AUT",
    "AZ": "AZE",
    "BS": "BHS",
    "BH": "BHR",
    "BD": "BGD",
    "BB": "BRB",
    "BY": "BLR",
    "BE": "BEL",
    "BZ": "BLZ",
    "BJ": "BEN",
    "BT": "BTN",
    "BO": "BOL",
    "BA": "BIH",
    "BW": "BWA",
    "BR": "BRA",
    "BN": "BRN",
    "BG": "BGR",
    "BF": "BFA",
    "BI": "BDI",
    "CV": "CPV",
    "KH": "KHM",
    "CM": "CMR",
    "CA": "CAN",
    "CF": "CAF",
    "TD": "TCD",
    "CL": "CHL",
    "CN": "CHN",
    "CO": "COL",
    "KM": "COM",
    "CG": "COG",
    "CD": "COD",
    "CR": "CRI",
    "HR": "HRV",
    "CU": "CUB",
    "CY": "CYP",
    "CZ": "CZE",
    "DK": "DNK",
    "DJ": "DJI",
    "DM": "DMA",
    "DO": "DOM",
    "EC": "ECU",
    "EG": "EGY",
    "SV": "SLV",
    "GQ": "GNQ",
    "ER": "ERI",
    "EE": "EST",
    "SZ": "SWZ",
    "ET": "ETH",
    "FJ": "FJI",
    "FI": "FIN",
    "FR": "FRA",
    "GA": "GAB",
    "GM": "GMB",
    "GE": "GEO",
    "DE": "DEU",
    "GH": "GHA",
    "GR": "GRC",
    "GD": "GRD",
    "GT": "GTM",
    "GN": "GIN",
    "GW": "GNB",
    "GY": "GUY",
    "HT": "HTI",
    "HN": "HND",
    "HU": "HUN",
    "IS": "ISL",
    "IN": "IND",
    "ID": "IDN",
    "IR": "IRN",
    "IQ": "IRQ",
    "IE": "IRL",
    "IL": "ISR",
    "IT": "ITA",
    "JM": "JAM",
    "JP": "JPN",
    "JO": "JOR",
    "KZ": "KAZ",
    "KE": "KEN",
    "KI": "KIR",
    "KW": "KWT",
    "KG": "KGZ",
    "LA": "LAO",
    "LV": "LVA",
    "LB": "LBN",
    "LS": "LSO",
    "LR": "LBR",
    "LY": "LBY",
    "LI": "LIE",
    "LT": "LTU",
    "LU": "LUX",
    "MG": "MDG",
    "MW": "MWI",
    "MY": "MYS",
    "MV": "MDV",
    "ML": "MLI",
    "MT": "MLT",
    "MH": "MHL",
    "MR": "MRT",
    "MU": "MUS",
    "MX": "MEX",
    "FM": "FSM",
    "MC": "MCO",
    "MN": "MNG",
    "ME": "MNE",
    "MA": "MAR",
    "MZ": "MOZ",
    "MM": "MMR",
    "NA": "NAM",
    "NR": "NRU",
    "NP": "NPL",
    "NL": "NLD",
    "NZ": "NZL",
    "NI": "NIC",
    "NE": "NER",
    "NG": "NGA",
    "KP": "PRK",
    "MK": "MKD",
    "NO": "NOR",
    "OM": "OMN",
    "PK": "PAK",
    "PW": "PLW",
    "PA": "PAN",
    "PG": "PNG",
    "PY": "PRY",
    "PE": "PER",
    "PH": "PHL",
    "PL": "POL",
    "PT": "PRT",
    "QA": "QAT",
    "KR": "KOR",
    "MD": "MDA",
    "RO": "ROU",
    "RU": "RUS",
    "RW": "RWA",
    "KN": "KNA",
    "LC": "LCA",
    "VC": "VCT",
    "WS": "WSM",
    "SM": "SMR",
    "ST": "STP",
    "SA": "SAU",
    "SN": "SEN",
    "RS": "SRB",
    "SC": "SYC",
    "SL": "SLE",
    "SG": "SGP",
    "SK": "SVK",
    "SI": "SVN",
    "SB": "SLB",
    "SO": "SOM",
    "ZA": "ZAF",
    "SS": "SSD",
    "ES": "ESP",
    "LK": "LKA",
    "SD": "SDN",
    "SR": "SUR",
    "SE": "SWE",
    "CH": "CHE",
    "SY": "SYR",
    "TJ": "TJK",
    "TH": "THA",
    "TL": "TLS",
    "TG": "TGO",
    "TO": "TON",
    "TT": "TTO",
    "TN": "TUN",
    "TR": "TUR",
    "TM": "TKM",
    "TV": "TUV",
    "UG": "UGA",
    "UA": "UKR",
    "AE": "ARE",
    "GB": "GBR",
    "TZ": "TZA",
    "US": "USA",
    "UY": "URY",
    "UZ": "UZB",
    "VU": "VUT",
    "VE": "VEN",
    "VN": "VNM",
    "YE": "YEM",
    "ZM": "ZMB",
    "ZW": "ZWE"
};



export const countryTranslationsKeyTemplate = (country: string) =>
{
    if (country.length === 2) {
        country = alpha2ToAlpha3Mapping[country];
    }

    return `COM_USERS_GROUP_COUNTRY_${country.toLocaleUpperCase()}`;
};

export const getCountriesTranslationsKeys = () =>
{
    return countries.map(country => countryTranslationsKeyTemplate(country.alpha3));
};